import React, { FunctionComponent } from 'react';

import Button from '../UI/Button';
import { sendEvent2 } from '../../utils/tracking';

const Helpline: FunctionComponent<any> = ({ loneElement = false }) => (
  <div className={loneElement ? 'flex falign-c justify-content-fe' : 'ib-c'}>
    <Button variant="text" icon="phone" style={{ pointerEvents: 'none', padding: '0' }}>
      Helpline 93700 93700
    </Button>
  </div>
);

export default Helpline;
